export default "__VITE_ASSET__B96PJtIt__"